import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import ClockJobTeamItem from './ClockJobTeamItem'
import { TargetModule } from '../text/TextModules.js'

import ModulesUtils from '../../../../infra/ModulesUtils'

class ClockingJobModule extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape(),
    dbPath: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state={
      jobInfo: props.jobInfo
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      jobInfo: nextProps.jobInfo
    })
  }

  renderWorkers() {
    const views = [];
    for (const key in this.state.jobInfo.modules.clockingTeam) {
      if (!this.state.jobInfo.modules.clockingTeam.hasOwnProperty(key)) {
        continue;
      }

      const workerName = ModulesUtils.getMemberName(this.props.teamMembers, key);
      if (workerName === 'No Name') {
        continue;
      }

      const workerInfo = this.state.jobInfo.modules.clockingTeam[key];
      if (workerInfo) {
        views.push(
          <ClockJobTeamItem
            key={key}
            name={workerName}
            clockInfo={workerInfo}/>);
      }
    }

    return views;
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'column'}}>
        { this.renderWorkers() }
        { this.state.jobInfo.modules.clockingTeam.target &&
          <div style={{ marginLeft: 10, width: 150}}>
            <TargetModule
              moduleName='clockingTeam'
              dbPath={this.props.dbPath}
              jobInfo={this.state.jobInfo}/>
          </div>
        }
      </div>
    );
  }
}

export default connect(state => ({ teamMembers: state.firebase.team.members.value }))(ClockingJobModule)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/clockJob/ClockJobTeamModule.js